/**
 * FitTopBar — shared sticky header for the /fit pillar surface.
 *
 * Extracted from pages/Fit.jsx so the /fit/walks (Walks) page can
 * wear identical chrome. Founder ruling 1 Jul 2026: "/walks lives
 * as a tab on /fit · header parity is non-negotiable".
 */
import React from "react";
import { Link } from "react-router-dom";
import ConciergeOnDutyPill from "@/components/global/ConciergeOnDutyPill";
import ConciergeSurfaceMenu from "@/components/global/ConciergeSurfaceMenu";
import CrossSurfaceNav from "@/components/global/CrossSurfaceNav";

const T = {
  bg:     "#F4EFE6",
  ink:    "#211C15",
  ink3:   "#8A8071",
  line:   "#E5DCCB",
};

export default function FitTopBar({ onHome, testid = "fit-header" }) {
  return (
    <header
      data-testid={testid}
      style={{
        borderBottom: `1px solid ${T.line}`,
        background: T.bg,
        position: "sticky",
        top: 0,
        zIndex: 20,
      }}
    >
      <div
        style={{
          maxWidth: 1180, margin: "0 auto",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "14px 22px", gap: 10, flexWrap: "nowrap", minWidth: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 14, minWidth: 0 }}>
          <Link
            to="/fit"
            onClick={(e) => { if (onHome) { e.preventDefault(); onHome(); } }}
            data-testid="fit-home-button"
            style={{ textDecoration: "none", color: T.ink, display: "inline-flex", alignItems: "baseline", gap: 10, minWidth: 0 }}
          >
            <span className="t-serif" style={{ fontSize: 22, fontWeight: 500, letterSpacing: "0.02em" }}>
              /fit
            </span>
            <span
              data-testid="fit-header-by-concierge"
              className="lc-mobile-hide-on-narrow"
              style={{
                fontFamily: "ui-monospace, monospace",
                fontSize: 11,
                letterSpacing: "0.22em",
                textTransform: "uppercase",
                color: T.ink3,
                whiteSpace: "nowrap",
              }}
            >
              by Concierge®
            </span>
          </Link>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
          <ConciergeOnDutyPill context="fit" />
          <CrossSurfaceNav testidPrefix="fit-header-nav" size="compact" />
          <ConciergeSurfaceMenu testid="fit-surface-menu" />
        </div>
      </div>
    </header>
  );
}
